import { render, staticRenderFns } from "./AppointmentAudioRecorder.vue?vue&type=template&id=78c9fac0&scoped=true"
import script from "./AppointmentAudioRecorder.vue?vue&type=script&lang=js"
export * from "./AppointmentAudioRecorder.vue?vue&type=script&lang=js"
import style0 from "./AppointmentAudioRecorder.vue?vue&type=style&index=0&id=78c9fac0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c9fac0",
  null
  
)

export default component.exports